import { render, staticRenderFns } from "./AnnualReports.vue?vue&type=template&id=77b7427b&scoped=true"
import script from "./AnnualReports.vue?vue&type=script&lang=js"
export * from "./AnnualReports.vue?vue&type=script&lang=js"
import style0 from "./AnnualReports.vue?vue&type=style&index=0&id=77b7427b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b7427b",
  null
  
)

export default component.exports